export default __webpack_public_path__ + "static/media/access_denied_fusindo.e26ae697.svg";